function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M13.574 12.75h-2.033a1.342 1.342 0 00-.5 2.587l2.064.826a1.342 1.342 0 01-.5 2.587h-2.031m1.5-6V12m0 7.5v-.75m-5.25-10.5h10.5M15.63 5.036l1.438-2.876a.75.75 0 00-1.006-1.006l-1.9.948a.75.75 0 01-.959-.255l-.503-.763a.75.75 0 00-1.248 0l-.509.763a.749.749 0 01-.959.255l-1.897-.948A.751.751 0 007.08 2.16l1.41 2.82",
  fill: "none",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M7.237 10.5l-2.76 3.2a5.932 5.932 0 004.7 9.549h5.79a5.932 5.932 0 004.7-9.549l-2.76-3.2",
  fill: "none",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5
});

function SvgMoneyBagDollar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    stroke: "currentColor"
  }, props), _ref, _ref2);
}

export default SvgMoneyBagDollar;